module.exports = __webpack_public_path__ + "static/media/jasper-29.242e10c2.jpg";